// utils/toast.js
import { lazy } from "react";
import { toast as baseToast } from "react-toastify";
import "./toast.css";
export const toast = baseToast;
export const LazyToastContainer = lazy(() =>
  import("react-toastify").then((m) => ({ default: m.ToastContainer }))
);
